import {EnvType, GlobalConfig} from "./appConfig";

const RouteName = {
	bridgeWebView: 'BridgeWebView', // H5 container
	scheduleViewController: 'ScheduleViewController',
	messagesViewController: 'MessagesViewController',
	myMonitorViewController: 'MyMonitorViewController',
	nearByPharmacyViewController: 'NearByPharmacyViewController',
	socialViewController: 'SocialViewController',
	medicationRecordViewController: 'MedicationRecordViewController',
	labReportsViewController: 'LabReportsViewController',
	visitHistoryViewController: 'VisitHistoryViewController',
	vaccinationViewController: 'VaccinationViewController',
	insuranceViewController: 'InsuranceViewController',
	filesHomeViewController: 'FilesHomeViewController',
	covidAppointmentInfoController: 'CovidAppointmentInfoController',
	howToListViewController: 'HowToListViewController',
	getDirectionViewController: "GetDirectionViewController",
	covidVaccineQualificationController: 'CovidVaccineQualificationController',
	somosLoginViewController: 'SomosLoginViewController',
	feedbackViewController: 'FeedbackViewController',
	errorPreview: 'ErrorPreview'
}

const FAQ = {
	questionList: '/faq/questionList',
	questionDetail: '/faq/questionDetail'
}


const Privacy = {
	termsOfUse: '/privacy/termsOfUse',
	policy: '/privacy/policy'
}

const FindDoctors = {
	findDoctor: '/findDoctor/find',
	appointmentDate: '/findDoctor/appointmentDate',
	doctorProfile: '/findDoctor/doctorProfile',
	appointmentDetail: '/findDoctor/appointmentDetail'
}

const spa = {
	vaccination: '/spa/vaccination/:token'
}

const Feedback = {
	selection: '/feedback/selection',
	edit: '/feedback/edit',
	confirm: '/feedback/confirm'
}

const MyMonitor = {
	home: '/myMonitor/home',
	detail: '/myMonitor/detail',
	list: '/myMonitor/list',
	add: '/myMonitor/add',
	measureHistory: '/myMonitor/measureHistory',
	measureDetail: '/myMonitor/measureDetail',
	unitSettings: '/myMonitor/unitSettings',
}

const H5RouteName = {
	dashboard: '/dashboard',
	vaccine: "/vaccine",
	vaccineRecord: "/vaccineRecord",
	vaccineAppointmentInfo: "/vaccineAppointmentInfo",
	faq: FAQ,
	privacy: Privacy,
	findDoctor: FindDoctors,
	idProofing: '/idProofing',
	spa: spa,
	feedback: Feedback,
	oa: '/oa',
	myMonitor: MyMonitor,
}

const H5AppUrl = {
	dev: 'https://api-app-d.mdland.com/iClinicHealth/#',
	uat: 'https://static-app.iclinichealth.net/#',
	pro: 'https://api-app-p.mdland.com/iClinicHealth/#'
}

const H5ContainerRouteBaseURL = () => {
	if (GlobalConfig.envType === EnvType.dev) {
		return H5AppUrl.dev
	}else if (GlobalConfig.envType === EnvType.uat) {//https://static-app.iclinichealth.net/#/findDoctor/find
		//'http://localhost:3000/#'//
		return H5AppUrl.uat
	} else {
		return H5AppUrl.pro
	}
}

const GetH5ContainerURL = (h5RoutName)=> {
	return H5ContainerRouteBaseURL() + h5RoutName
}

const FAQ_Image_BaseURL = 'https://viphealth-image.s3.amazonaws.com/'

export {
	RouteName,
	H5RouteName,
	GetH5ContainerURL,
	FAQ_Image_BaseURL,
	H5AppUrl
}
